import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {ContentHotel} from '@findhotel/sapi'
import {ReviewsSection} from 'components/Accommodation/ReviewsSection'
import {getReviewAvailability} from 'components/Accommodation/ReviewsSection/utils'

import {Divider} from '@vio/atlas/Divider'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

const Wrapper = styled.div`
  ${linariaMq.desktopXs} {
    padding-bottom: ${cssTheme.layout.spacing.s000};
    padding-top: ${cssTheme.layout.spacing.s700};
    padding-left: ${cssTheme.layout.spacing.s500};
    padding-right: ${cssTheme.layout.spacing.s500};
    &.--mounted-on-overlay {
      padding-top: ${cssTheme.layout.spacing.s600};
    }
  }
`

interface Props {
  hotel: ContentHotel
  reviewsRef?: React.RefObject<HTMLDivElement>
  isFullLayout?: boolean
  mountedOnOverlay?: boolean
}
export const ConditionalReviews = ({
  hotel,
  reviewsRef,
  isFullLayout = false,
  mountedOnOverlay = false
}: Props) => {
  const {hasAnyReviewComponent} = getReviewAvailability(hotel)
  const shouldRenderReviews = !hotel || hasAnyReviewComponent

  if (!shouldRenderReviews) return null

  return (
    <>
      {mountedOnOverlay ? null : <Divider sideMargin="s500" />}
      <>
        <Wrapper className={cx(mountedOnOverlay && '--mounted-on-overlay')}>
          <ReviewsSection
            anchorRef={reviewsRef}
            hotel={hotel}
            isFullLayout={isFullLayout}
            mountedOnOverlay={mountedOnOverlay}
          />
        </Wrapper>
      </>
    </>
  )
}
